import { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { ConfigContext } from '../Common/ConfigHelper';
import { GlobalContext } from '../../contexts/GlobalContext';
import TrustIcon from '../../info/Include/images/TrustIcon.svg';
import NotTrustIcon from '../../info/Include/images/NotTrustIcon.svg';
import { useWindowSize, timeoutPromise } from '../Common/CommonHooks';
import { useAdobeLaunch } from '../Common/utils/adobeLaunch';
import LoginLoading from '../Common/ui-components/LoginLoading';

export const TrustBrowser = ({
    showMsg = false,
    FR_TurstBrowser = FR_TurstBrowser,
    isShowTrustBrowser = isShowTrustBrowser,
    setIsShowTrustBrowser = setIsShowTrustBrowser,
    checkIsEod = checkIsEod,
    isVoiceOTP,
    setLoginIncorrectMsg = setLoginIncorrectMsg,
    isSecurityPin
    
}) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { betslipMenu } = useContext(ConfigContext);
    const globalContext = useContext(GlobalContext);
    const [menuInfo, setMenuInfo] = useState(betslipMenu);

    const { isMobileSize } = useWindowSize();
    const [selectTrust,setSelectTrust] = useState(null);
    const [showTandC,setshowTandC]= useState(false);
    let mobileStyle = isMobileSize ? 'is-mobile' : 'is-desktop';
    const [isClicked,setIsClicked] = useState(false);

    const { sendAdobeEvent } = useAdobeLaunch()

    useEffect(() => {
        if (isMobileSize) {
            mobileStyle = 'is-mobile'
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobileSize]);
    
    
    const handleTrustBtn = async () => {
        if(!isClicked){
            
            try {
                let isEod = await Promise.race([checkIsEod(), timeoutPromise()]);
                // const isEod = await checkIsEod();
                //isshownewekba
                if (!isEod) {
                    if(!!window.sessionStorage.getItem("LoginWA") && window.sessionStorage.getItem("LoginWA").includes('WithMobile')) {                        
                        sendAdobeEvent({
                            event: 'interaction',
                            interaction: { eventID: `eWin_CIAM_S2-Trust-Yes_whitelistWithMobile${isVoiceOTP?'-VoiceOTP': isSecurityPin?'-PIN':''}` }
                        });
                        
                    }else if(!!window.sessionStorage.getItem("LoginWA") && window.sessionStorage.getItem("LoginWA").includes('WithoutMobile')){
                        sendAdobeEvent({
                            event: 'interaction',
                            interaction: { eventID: 'eWin_CIAM_S2-Trust-Yes_whitelistWithoutMobile' }
                        });                       
                    }

                    window.sessionStorage.setItem("LoginWA", sessionStorage.getItem("LoginWA") + "_Trust-Yes");
                    // trust the browser
                    // close overlay modal
                    let result = await FR_TurstBrowser(true);
                    if(result){
                        setshowTandC(true);
                       // setIsShowTrustBrowser(false);
                    }
                    //
                    setIsClicked(false);
                }
            } catch (err) {
                console.log(err);
                if (err.message === 'Request timed out') {
                    setLoginIncorrectMsg('TIMEOUT');
                } else {
                    setLoginIncorrectMsg('OTHER');
                }
            }   

        }        
    };

    const handleDontTrustBtn = async () => {
   
        if(!isClicked){
            try {
                let isEod = await Promise.race([checkIsEod(), timeoutPromise()]);
                // const isEod = await checkIsEod();
                //isshownewekba
                if (!isEod) {
                    if(!!window.sessionStorage.getItem("LoginWA") && window.sessionStorage.getItem("LoginWA").includes('WithMobile')) {                        
                        sendAdobeEvent({
                            event: 'interaction',
                            interaction: { eventID: `eWin_CIAM_S2-Trust-No_whitelistWithMobile${isVoiceOTP?'-VoiceOTP':isSecurityPin?'-PIN':''}` }
                        });
                        
                    }
                    else if(!!window.sessionStorage.getItem("LoginWA") && window.sessionStorage.getItem("LoginWA").includes('WithoutMobile')){
                        sendAdobeEvent({
                            event: 'interaction',
                            interaction: { eventID: 'eWin_CIAM_S2-Trust-No_whitelistWithoutMobile' }
                        });                       
                    }
                    if(!!window.sessionStorage.getItem("LoginWA") && !window.sessionStorage.getItem("LoginWA").includes('_Trust-No')) {
                        window.sessionStorage.setItem("LoginWA", sessionStorage.getItem("LoginWA") + "_Trust-No");
                    }
                    let result = await FR_TurstBrowser(false);
                    console.debug(result,'result')
                    if(result){
                        setshowTandC(true);
                        //setIsShowTrustBrowser(false);
                    }
                    setIsClicked(false);
                }
            } catch (err) {
                console.log(err);
                if (err.message === 'Request timed out') {
                    setLoginIncorrectMsg('TIMEOUT');
                } else {
                    setLoginIncorrectMsg('OTHER');
                }
            }   

         
        }
        // close overlay modal
    };
    const handleSubmit=()=> {
        if(isClicked)return;
        
        if(selectTrust) {
            handleTrustBtn()
            setIsClicked(true)
        }
        else if (selectTrust==false) {
            handleDontTrustBtn()
            setIsClicked(true)
        }
    }
    
    
    return (
        <Popup open={showMsg} closeOnEscape={false} closeOnDocumentClick={false} className={`comingSoonLogOutDialog logout-succ-msg trustbrowser ${mobileStyle}`}>
            <div className={`trustbrowser-container`} id='popup-trustbrowser-container'>
                <div className='trustbrowser-title-and-description'>
                    <div className='trustbrowser-header'>
                        <div className="trustbrowser-dialog-title" id="trustTitle">{t('LB_TRUSTED_BROWSER_TITLE')}</div>
                        <div className="trustbrowser-message" id="choose_option" dangerouslySetInnerHTML={{ __html: t('LB_TRUSTED_BROWSER_MESSAGE') }}></div>
                    </div>
                    <div className='trustbrowser-content-container'>
                        <div id="notTrustButton" className={`trustbrowser-container2 ${selectTrust&&'trustbrowser-active'}`} onClick={()=>{setSelectTrust(true)}}>
                            <div >
                                <img src={TrustIcon} alt="trust browser img" />
                            </div>
                            <div>
                                <div className="trustbrowser-title">{t('LB_TRUSTED_BROWSER_TRUST')}</div>
                                <div className="trustbrowser-message" dangerouslySetInnerHTML={{ __html: t('LB_TRUSTED_BROWSER_TRUST_MSG') }}></div>
                            </div>
                        </div>
                        <div id="trustButton" className={`trustbrowser-container2 ${selectTrust===false&&'trustbrowser-active'}`} onClick={()=>{setSelectTrust(false)}} >
                            <div>
                                <img src={NotTrustIcon} alt="trust browser img" />
                            </div>
                            <div>
                                <div className="trustbrowser-title">{t('LB_TRUSTED_BROWSER_DONT_TRUST')}</div>
                                <div className="trustbrowser-message" dangerouslySetInnerHTML={{ __html: t('LB_TRUSTED_BROWSER_DONT_TRUST_MSG') }}></div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="trustbrowser-btn-group">
                    {/* <div className="trustbrowser-btn-donttrust" onClick={handleDontTrustBtn}>{t('LB_TRUSTED_BROWSER_DONT_TRUST')}</div> */}
                    <div id="next" className={`trustbrowser-btn-next cta_yellow ${selectTrust!==null&&"trustbrowser-btn-trust"}`} onClick={()=>{handleSubmit()}}>{t('LB_NEXT')}</div>
                </div>
                {isClicked && <div className='loginLoading'>
                    <LoginLoading></LoginLoading>
                </div>}
            </div>
        </Popup>
    );
};